import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { RootState } from 'src/redux/redux-store';
import { ReduxState } from 'src/redux/redux-state';

const sanitizeClientId = (value?: string | null): string | undefined => {
  if (!value || value === 'undefined' || value === 'null') {
    return undefined;
  }
  return value;
};

/** Staff impersonation param for `/api/v1`; omitted for client users. */
export function useSurveysBetaExtClientId(): string | undefined {
  const { clientId } = useParams<{ clientId?: string }>();
  const [searchParams] = useSearchParams();
  const userState = useSelector((state: ReduxState) => state.userState);
  const activeClient = useSelector((state: RootState) => state.userState.activeClient);

  const isClientView =
    userState.permissions?.groups?.includes('client_user') ||
    userState.permissions?.groups?.includes('client_admin');

  if (isClientView) {
    return undefined;
  }

  return (
    sanitizeClientId(clientId) ||
    sanitizeClientId(searchParams.get('previewClientId')) ||
    sanitizeClientId(activeClient?.ext_client_id)
  );
}
